import { AuthApi } from "@/api/AuthApi";
import { useOperationSupportLog } from "@/composable/operation_support/log";
import { OperationSupportLog } from "@/types/OperationSupport";

export class AuthService {

  /**
   * Laravel SanctumでCSRF保護を初期化します
   * @returns 
   */
  public async sanctum(): Promise<boolean> {
    const api = new AuthApi()
    const { saveLog } = useOperationSupportLog()

    try {
      const log = new OperationSupportLog()
      await log.setLogInfo('Sanctum認証API（クライアントサイド）', '認証APIの実行', '処理開始')
      await saveLog(log)
    } catch (e) {
      // ログの記録失敗時に処理続行するよう握りつぶす
    }
    try {
      await api.sanctum()
      return true
    } catch (e: any) {
      // MEMO: 基本的に失敗することはない
      try {
        const log = new OperationSupportLog()
        await log.setLogInfo('Sanctum認証API（クライアントサイド）', '認証APIの実行', '失敗', e)
        await saveLog(log)
      } catch (e) {
        // ログの記録失敗時に処理続行するよう握りつぶす
      }
      return false
    }
  }

}